<div class="container" [ngStyle]="{ background: backgroundColor() }">
  <orbit-title [textValue]="titleValue()" size="lg" />
  <!-- <orbit-fa-icon [iconClass]="'fa-solid fa-phone'" [iconSize]="18" /> -->
</div>
